<script lang="ts">
	//Stores
	import { user_data } from 'src/stores/account/user';
	//Services
	import { postReq } from '../../../services/http';
	import { format } from '../../../services/i18n';
	//Design system components
	import { Button, Alert, Text, toast } from '@Shelly/shelly-design-system';
	import { timestampToDate } from 'src/helpers/date_helper';
	import RevokeConfirmationModal from './RevokeConfirmationModal.svelte';
	import CountdownTimer from './CountdownTimer.svelte';
	import { isSupportAccessExpired } from 'src/helpers/account_helpers';

	let revokeShowModal = false;

	//description and value are reactive because of the timer
	$: description = $user_data?.tmpk_valid
		? $format('info_support_access_granted', {
				values: {
					value: timestampToDate(
						new Date($user_data.tmpk_valid.replace(/\s+/g, 'T')).getTime(),
					),
				},
			})
		: $format('info_grant_account_access_message');

	$: supportAccessExpiry = $user_data?.tmpk_valid
		? new Date($user_data.tmpk_valid.replace(/\s+/g, 'T')).getTime()
		: null;

	const grant_access = async () => {
		let res = await postReq('user/get_support_access', {
			'back-door': 'enable',
		});
		const data = res.data;
		if (res.isok) {
			user_data.set({ ...$user_data, tmpk_valid: data.ts });
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
		}
	};

	const disable_access = async () => {
		if (isSupportAccessExpired(supportAccessExpiry)) {
			user_data.remove('tmpk_valid');
			revokeShowModal = false;
			return;
		}

		let res = await postReq('user/remove_support_access', {
			'back-door': 'disable',
		});
		if (res.isok) {
			user_data.remove('tmpk_valid');
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
		}
		revokeShowModal = false;
	};
</script>

{#if $user_data?.tmpk_valid}
	<Alert class="mb-s" heading={description} />
	<div class="d-flex align-items-center">
		<Button
			size="m"
			on:click={() => (revokeShowModal = true)}
			class="mr-s width-md-auto width-sm-full"
		>
			{$format('button_revoke_access', {
				default: 'Revoke access',
			})}
		</Button>
		{#if supportAccessExpiry > new Date().getTime()}
			<CountdownTimer targetTime={supportAccessExpiry} />
		{/if}
	</div>
{:else}
	<Text class="mb-s" styleType="body-small">
		{description}
	</Text>
	<Button size="m" on:click={() => grant_access()} class="width-md-auto width-sm-full">
		{$format('button_grant_access')}
	</Button>
{/if}

<RevokeConfirmationModal
	bind:showModal={revokeShowModal}
	on:revoke={() => disable_access()}
	mainText={$format('message_modal_revoke_access', {
		default:
			'Revoking account access will immediately disconnect the support and remove their permissions from your account.',
	})}
/>
